<template>
  <div class="row mb-3">
    <div class="col-sm-3">
      <label for="input_content">
        Content
        <p class="mt-2" v-if="isEditable">
          คำอธิบายแบบยาว <br />
          <b-button
            size="sm"
            variant="warning"
            @click="isImageSingleUploadShow = !isImageSingleUploadShow"
            ><i :class="`${'bx bx-image f-18'}`"></i>Upload Image</b-button
          >
          <ModalImageSingleUpload
            v-model="isImageSingleUploadShow"
            title="สร้าง URL จากรูปที่นำเข้า"
            :path="'categories/contents' + (PathId ? '/' + PathId : '')"
            contentDescription="pim-product-content"
          ></ModalImageSingleUpload>
        </p>
      </label>
    </div>
    <div class="col-sm-9">
      <div class="row">
        <div class="col-sm-6">
          <!-- {{content.th}} -->
          <!-- <tinymce
            class="relative d-block form-group"
            :id="'input_contentTH' + id"
            v-model="content.th"
            :plugins="plugins"
            :toolbar="toolbar"
            :other_options="options"
          ></tinymce> -->
          <editor
            v-model="content.th"
            :disabled="!isEditable"
            api-key="no-api-key"
            :init="{
              menubar: false,
              height: 200,
              plugins: plugins,
              toolbar: toolbar,
            }"
          />
        </div>
        <div class="col-sm-6">
          <!-- {{content.en}} -->
          <editor
            v-model="content.en"
            :disabled="!isEditable"
            api-key="no-api-key"
            :init="{
              menubar: false,
              height: 200,
              plugins: plugins,
              toolbar: toolbar,
            }"
          />
          <!-- <tinymce
            class="relative d-block form-group"
            :id="'input_contentEN'+id"
            v-model="test"
            :plugins="plugins"
            :toolbar="toolbar"
            :other_options="options"
          ></tinymce> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalImageSingleUpload from './modal-image-single-upload.vue'
import Editor from '@tinymce/tinymce-vue'
// import tinymce from 'vue-tinymce-editor'
import { v4 as uuidv4 } from 'uuid'
export default {
  components: {
    ModalImageSingleUpload,
    //tinymce
    editor: Editor,
  },
  props: {
    value: {
      type: Object,
      default: () => ({ en: '', th: '' }),
    },
    id: {
      type: String,
      default: () => uuidv4(),
    },
    PathId: {
      type: String,
      default: '',
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // Tinymce Editor
      init: {},
      plugins: [
        'advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker',
        'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking',
        'save table contextmenu directionality emoticons template paste textcolor',
      ],
      toolbar:
        'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l ink image | print preview media fullpage | forecolor backcolor emoticons',
      options: {
        height: 200,
        style_formats: [
          { title: 'Bold text', inline: 'b' },
          { title: 'Red text', inline: 'span', styles: { color: '#ff0000' } },
          { title: 'Red header', block: 'h1', styles: { color: '#ff0000' } },
          { title: 'Example 1', inline: 'span', classes: 'example1' },
          { title: 'Example 2', inline: 'span', classes: 'example2' },
          { title: 'Table styles' },
          { title: 'Table row 1', selector: 'tr', classes: 'tablerow1' },
        ],
      },
      isImageSingleUploadShow: false,
    }
  },
  computed: {
    content: {
      get() {
        // console.log('computed', this.value)
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  /*   watch:{
      value: {
      handler(val) {
        // console.log('val', val)      
        this.content = val;
        // this.componentModelOriginal = Object.assign({},val)
      },
      deep: true,
    },
  }, */
  /*  mounted () {
    this.content = this.value;
  }, */
}
</script>

<style scoped></style>
